module.exports = __webpack_public_path__ + "img/welcome-image-hsp1.ec0a99a5.png";